<div class="dialog-header">
  <label class="textColour">{{ titleText }}</label>
  <span class="example-spacer"></span>
</div>

<form [formGroup]="form" class="action-form">

  <!-- Hidden ID -->
  <input type="hidden" formControlName="actionId" />

  <div class="grid-2">

    <!-- Action Name -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Action Name</mat-label>

      <mat-select formControlName="actionName">

        <mat-option
          *ngFor="let item of actionNameList"
          [value]="item.lookupvalue || item.value">

          {{ item.lookupvalue || item.value }}

        </mat-option>

      </mat-select>

      <mat-error *ngIf="isInvalid('actionName')">
        Action Name is required
      </mat-error>

    </mat-form-field>


    <!-- Action Other -->
    <mat-form-field
      *ngIf="showOtherInput"
      appearance="outline"
      class="full-width">

      <mat-label>Specify Action Name</mat-label>

      <input
        matInput
        formControlName="actionOther"
        placeholder="Enter custom action name" />

      <mat-error *ngIf="isInvalid('actionOther')">
        Please specify the action name
      </mat-error>

    </mat-form-field>


    <!-- Action Origin -->
    <mat-form-field appearance="outline" class="full-width">

      <mat-label>Action Originating From</mat-label>

      <mat-select formControlName="actionOrigin">

        <mat-option
          *ngFor="let item of actionOriginList"
          [value]="item.lookupvalue || item.value">

          {{ item.lookupvalue || item.value }}

        </mat-option>

      </mat-select>

      <mat-error *ngIf="isInvalid('actionOrigin')">
        Action Origin is required
      </mat-error>

    </mat-form-field>


    <!-- Action Priority -->
    <mat-form-field appearance="outline" class="full-width">

      <mat-label>Action Priority</mat-label>

      <mat-select formControlName="actionPriority">

        <mat-option
          *ngFor="let item of actionPriorityList"
          [value]="item.lookupvalue || item.value">

          {{ item.lookupvalue || item.value }}

        </mat-option>

      </mat-select>

      <mat-error *ngIf="isInvalid('actionPriority')">
        Action Priority is required
      </mat-error>

    </mat-form-field>


    <!-- Due Date -->
    <mat-form-field appearance="outline" class="full-width">

      <mat-label>Due Date</mat-label>

      <input
        matInput
        [matDatepicker]="dueDatePicker"
        formControlName="dueDate" />

      <mat-datepicker-toggle
        matSuffix
        [for]="dueDatePicker">
      </mat-datepicker-toggle>

      <mat-datepicker #dueDatePicker></mat-datepicker>

      <!-- ADDED: Due Date error message -->
      <mat-error *ngIf="isInvalid('dueDate')">
        Due Date is required
      </mat-error>

    </mat-form-field>

  </div>


  <!-- Description -->
  <mat-form-field appearance="outline" class="full-width">

    <mat-label>Action Description</mat-label>

    <textarea
      matInput
      rows="4"
      formControlName="actionDescription">
    </textarea>

    <mat-error *ngIf="isInvalid('actionDescription')">
      Description is required
    </mat-error>

  </mat-form-field>

  <!-- Buttons -->
  <div class="actions" style="margin-top: 20px; display: flex; gap: 10px; justify-content: flex-end;">
    <app-common-button
      label="Back"
      title="Back"
      [buttonId]="1111"
      width="110px"
      [critical]="false"
      variant="cancel"
      (clicked)="close()">
    </app-common-button>

    <app-common-button
      label="{{ isEditMode ? 'Update' : 'Submit' }}"
      title="{{ isEditMode ? 'Update' : 'Submit' }}"
      [buttonId]="1111"
      width="110px"
      [critical]="false"
      (clicked)="save()">
    </app-common-button>
  </div>

</form>